<p><b>Выключенный выбор даты</b></p>
<div class="box">
  <pa-datepicker
    placeholder="Выберите дату"
    [formControl]="disabledDateControl">
  </pa-datepicker>
</div>

<p><b>Выключенный диапазон дат</b></p>
<div class="box">
  <pa-datepicker-range
    placeholder="Выберите период"
    [formControl]="disabledDateRangeControl">
  </pa-datepicker-range>
</div>

<p><b>Обычный выбор даты</b></p>
<div class="box">
  <pa-datepicker
    placeholder="Выберите дату"
    [formControl]="dateControl">
  </pa-datepicker>
</div>

<p><b>Выбор даты и времени</b></p>
<div class="box">
  <pa-datepicker
    placeholder="Выберите дату и время"
    [formControl]="dateTimeControl"
    [showTime]="true">
  </pa-datepicker>
</div>

<p><b>Только месяц</b></p>
<div class="box">
  <pa-datepicker
    [formControl]="monthControl"
    [view]="'month'">
  </pa-datepicker>
</div>

<p><b>Только время</b></p>
<div class="box">
  <pa-datepicker
    placeholder="Выберите время"
    [formControl]="timeOnlyControl"
    [showTime]="true"
    [showSeconds]="true"
    [timeOnly]="true">
  </pa-datepicker>
</div>

<p><b>Дата и время с секундами</b></p>
<div class="box">
  <pa-datepicker
    placeholder="Выберите дату и время"
    [formControl]="dateTimeWithSecondsControl"
    [showTime]="true"
    [showSeconds]="true">
  </pa-datepicker>
</div>

<p><b>Обязательное поле</b></p>
<div class="box">
  <pa-datepicker
    label="Обязательная дата"
    placeholder="Выберите дату"
    [formControl]="requiredDateControl"
    hint="Это поле обязательно для заполнения">
  </pa-datepicker>
</div>

<p><b>Диапазон дат</b></p>
<div class="box">
  <pa-datepicker-range></pa-datepicker-range>
</div>

<p><b>Диапазон дат с подсказкой</b></p>
<div class="box">
  <pa-datepicker-range
    label="Период с подсказкой"
    tooltip="Это подсказка для поля выбора периода"
    hint="Поле с подсказкой">
  </pa-datepicker-range>
</div>